import { ModelBase } from "@shoothill/core";
import { observable, action } from "mobx";

export class GenericPhotoListItemModel extends ModelBase<GenericPhotoListItemModel> {
    @observable
    public id: string | null = null;
    @observable
    public fileName: string = "";
    @observable
    public photoURL: string = "";
    @observable
    public isDeleted: boolean = false;
    @observable
    public createdByUserId: string | null = "";
    @observable
    public createdDate: string | null = "";
    constructor() {
        super();
    }

    @action
    public handleDelete = (val: boolean) => {
        this.isDeleted = val;
    };

    fromDto(model: GenericPhotoListItemDTO): void {
        this.id = model.id;
        this.fileName = model.fileName;
        this.photoURL = model.photoURL;
        this.isDeleted = model.isDeleted;
        this.createdByUserId = model.createdByUserId;
        this.createdDate = model.createdDate;
    }

    public static fromDtos(dtos: GenericPhotoListItemDTO[]): GenericPhotoListItemModel[] {
        const types: GenericPhotoListItemModel[] = [];

        for (const dto of dtos) {
            const model = new GenericPhotoListItemModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    toDto(): GenericPhotoListItemDTO {
        return {
            id: this.id,
            fileName: this.fileName,
            photoURL: this.photoURL,
            isDeleted: this.isDeleted,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
        };
    }
}

export interface GenericPhotoListItemDTO {
    id: string | null;
    fileName: string;
    photoURL: string;
    isDeleted: boolean;
    createdByUserId: string | null;
    createdDate: string | null;
}
